<script setup lang="ts">
  import { onMounted, useTemplateRef } from 'vue'

  const emit = defineEmits(['confirm', 'cancel'])
  const rootEl = useTemplateRef<HTMLDivElement>('rootEl')

  onMounted(() =>
    rootEl.value?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }),
  )
</script>

<template>
  <div
    class="w-full max-w-2xl rounded-xl border border-red-400/80 bg-purple-500 p-8 text-white shadow-2xl"
    ref="rootEl"
  >
    <div class="flex h-full flex-col">
      <h2 class="font-display mb-2 text-center text-3xl font-bold">Close the Island?</h2>

      <!-- Input Section -->
      <div class="my-12 flex flex-col items-center gap-4 text-center">
        <p>Are you sure you'd like to stop hosting this island?</p>
        <p>This will remove everyone from the island and the queue.</p>
      </div>

      <!-- Action -->
      <div class="flex justify-center gap-4">
        <button
          @click="emit('confirm')"
          class="cursor-pointer rounded-lg bg-green-400 px-8 py-2 font-bold text-black transition-colors hover:bg-green-500"
        >
          Stop Hosting
        </button>

        <button
          @click="emit('cancel')"
          class="bg-base-orange cursor-pointer rounded-lg px-8 py-2 font-bold text-black transition-colors hover:bg-red-500"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
